<script>
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import formcheckbox from "@/router/views/formcomponet/formcheckbox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlptalep from "@/models/tlptalep"; 
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, tlptalep],
  props: ["Id", "AddEdit", "Geldigiyer"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
      Belgeler: [],
      KaydetButton: false,
      YonetimYetki: false,
      
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE
    };
  },
  components: {
    forminput,
    formtextarea,
    formdate, treeselect,formcheckbox
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.FormData.Aciklama = this.stripHtml(this.FormData.Aciklama)

    },
    "FormData.Ilid"(){
      this.IlceGet()
    }
  },
  methods: {
    IlceGet(){ 
      const item = this.FormDataType.Ilid.ComboDataArray.find(item => item.id === this.FormData.Ilid);
      this.ActionsFilterGet({ Service: "oililce", FullData: true, Filter: "&Ustid=" + item.kod }).then((res) => {
        this.FormDataType.Ilceid.ComboDataArray = res.Data.map(item => ({
          id: item.Id,
          label: item.Value
        }));
      });
    },
    async onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) { 
        this.KaydetButton = true


        if(this.FormData.Atananbirimid == null && this.FormData.Atananpersonelid != null){ 
          const opersonel = await this.ActionsFilterGet({ Service: "opersonel", FullData: true, Filter: "&Id="+ this.FormData.Atananpersonelid }) 
           this.FormData.Atananbirimid = opersonel.Data[0].Birimid
        } 

        if (this.AddEdit == "Add") {
          this.FormData.Talipsahipuserid = this.TokenUserId

          if(this.APPLICATION_TYPE == "3"){ 
            const today = new Date();
            today.setDate(today.getDate() + 10);
            this.FormData.Tahminibitis = today.toISOString().slice(0, 10); 
          }

          var res = await this.Post("tlptalep", this.FormData) 
            if (res) {

              if(this.Belgeler.length > 0){
                    var FormData = []
                    this.Belgeler.forEach(item => { 
                    FormData.push({
                      Talepid: res,
                      Baslik: item.Filename,
                      Olusturanid: this.TokenPersonelId,
                      Dosyayolu: item.Fileurl
                      })
                    })
                     
                    var tlptalepbelge =   await this.PostList("tlptalepbelge/postlist", FormData)
                    if(tlptalepbelge){
                      this.Belgeler = []
                    }
              }
              this.FormData = this.tlptalepData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
            else{
              this.KaydetButton = false
            }
           
        } else {
          
          if(!this.FormData.Tahminibitis){
            this.FormData.Tahminibitis = null
          }
          this.FormData.Lastmodifiedby = this.TokenUserId
          this.Update("tlptalep", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.tlptalepData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
            else{
              this.KaydetButton = false
            }
          });
        }
      }
    },
    Get() { this.KaydetButton = false},
    
    FileUpload(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf" || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
       
              this.Belgeler.push({ 
                      Filename: file.name,
                      Fileurl: res.Data.filename,
                      dosya_uzantisi: "." + uzanti
              })
              this.$toast.success("Dosya yüklendi");
           
          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
    BelgeSil(index){
      this.Belgeler.splice(index, 1)
    }, 
    stripHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },
  },
  created(){
     
    if(this.UserRolles.find(item => item === "SuperAdmin"  || item === "TlpAdmin"  )){
      this.YonetimYetki = true
    }
    else{
      this.YonetimYetki = false
      /*
      this.FormDataType.Baslik.Disabled = "disabled"
      this.FormDataType.Aciklama.Disabled = "disabled"
      this.FormDataType.Olusturanid.disabled  = "disabled"
      //this.FormDataType.Taleptipid.disabled  = "disabled"
      this.FormDataType.Uygulamaid.disabled  = "disabled"
      this.FormDataType.Oncelikid.disabled  = "disabled"
      */
    }
  }
}; 
</script>
<template>
  <b-modal v-model="ModalOpen" id="tlptalep" size="lg" :title="this.AddEdit == 'Edit'
      ? 'Kayıt Düzenle'
      : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">
 
      <div class="row">  
        <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik" :v="v$.FormData.Baslik"
          @input="FormData.Baslik = $event.target.value"  />
 
          <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Olusturanid.FieldTitle" v-if="Geldigiyer != '2'"
          :key="FormData.Olusturanid">
          <treeselect :multiple="false" :options="FormDataType.Olusturanid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Olusturanid" :disabled="FormDataType.Olusturanid.disabled"
            />
          <treeselect-value :value="FormData.Olusturanid" />
        </b-form-group>

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Taleptipid.FieldTitle"
          :key="FormData.Taleptipid">
          <treeselect :multiple="false" :options="FormDataType.Taleptipid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Taleptipid" :disabled="FormDataType.Taleptipid.disabled"/>
          <treeselect-value :value="FormData.Taleptipid" />
          <span v-if="v$.FormData.Taleptipid.$error">{{  $t("ValidationMessage.required") }}</span>
        </b-form-group>
        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Uygulamaid.FieldTitle"
                  :key="FormData.Uygulamaid" v-if="APPLICATION_TYPE == 1">
                  <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                    placeholder="Seçiniz..." v-model="FormData.Uygulamaid"  :disabled="FormDataType.Uygulamaid.disabled"/>
                  <treeselect-value :value="FormData.Uygulamaid" />
                  <span v-if="v$.FormData.Uygulamaid.$error">{{  $t("ValidationMessage.required") }}</span>
                </b-form-group>

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle" v-if="Geldigiyer != '2'"
          :key="FormData.Atananbirimid">
          <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Atananbirimid" :disabled="FormDataType.Atananbirimid.disabled" />
          <treeselect-value :value="FormData.Atananbirimid" />
        </b-form-group>
 

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
          :key="FormData.Oncelikid">
          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Oncelikid" :disabled="FormDataType.Oncelikid.disabled" />
          <treeselect-value :value="FormData.Oncelikid" :disabled="FormDataType.Oncelikid.disabled"  />
          <span v-if="v$.FormData.Oncelikid.$error">{{  $t("ValidationMessage.required") }}</span>
        </b-form-group>

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Destekoncelikid.FieldTitle"
          :key="FormData.Destekoncelikid">
          <treeselect :multiple="false" :options="FormDataType.Destekoncelikid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Destekoncelikid" :disabled="FormDataType.Destekoncelikid.disabled" />
          <treeselect-value :value="FormData.Destekoncelikid" :disabled="FormDataType.Destekoncelikid.disabled"  />
        </b-form-group>

     

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Durumid.FieldTitle"  
          :key="FormData.Durumid" v-if="this.AddEdit == 'Edit' && Geldigiyer != '2'">
          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Durumid"  :disabled="FormDataType.Durumid.disabled"  />
          <treeselect-value :value="FormData.Durumid" />
        </b-form-group>


        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Atananpersonelid.FieldTitle" v-if="Geldigiyer != '2'"
          :key="FormData.Atananpersonelid">
          <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Atananpersonelid" :disabled="FormDataType.Atananpersonelid.disabled" />
          <treeselect-value :value="FormData.Atananpersonelid" />
        </b-form-group>

        
        
        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Atanantemsilciid.FieldTitle" v-if="Geldigiyer != '2'"
          :key="FormData.Atanantemsilciid">
          <treeselect :multiple="false" :options="FormDataType.Atanantemsilciid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Atanantemsilciid" :disabled="FormDataType.Atanantemsilciid.disabled" />
          <treeselect-value :value="FormData.Atanantemsilciid" />
        </b-form-group>

        <formdate class="col-lg-6" :FormDataType="FormDataType.Tahminibitis" :Value="FormData.Tahminibitis" v-if="Geldigiyer != '2'"
          :v="v$.FormData.Tahminibitis" @input="FormData.Tahminibitis = $event.target.value" />
 
          <formcheckbox  class="col-lg-6"  v-if="APPLICATION_TYPE == 1 && 1 == 2"
        :FormDataType="FormDataType.Ucretli"
        :Value="FormData.Ucretli"
        :v="v$.FormData.Ucretli"
        @input="FormData.Ucretli = $event.target.checked"
      />

      <b-form-group class="col-lg-6" v-if="APPLICATION_TYPE == 1"   :label="FormDataType.Ucretli.FieldTitle" >  
      <b-form-checkbox  v-model="FormData.Ucretli" ></b-form-checkbox> </b-form-group>


          <forminput class="col-lg-6" :FormDataType="FormDataType.Isgucu" :Value="FormData.Isgucu" :v="v$.FormData.Isgucu"
          @input="FormData.Isgucu = $event.target.value" v-if="YonetimYetki"/>
 
          <forminput class="col-lg-6" :FormDataType="FormDataType.Harcananzaman" :Value="FormData.Harcananzaman" :v="v$.FormData.Harcananzaman"
          @input="FormData.Harcananzaman = $event.target.value" v-if="YonetimYetki ||  TokenPersonelId == FormData.Atananpersonelid " />

 
          

      <b-form-group class="col-lg-6"  v-if="APPLICATION_TYPE == 2" label-for="text" :label="FormDataType.Ilid.FieldTitle"
        :key="FormData.Ilid">
        <treeselect :multiple="false" :options="FormDataType.Ilid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Ilid" />
        <treeselect-value :value="FormData.Ilid" />
      </b-form-group>

      <b-form-group class="col-lg-6"  v-if="APPLICATION_TYPE == 2" label-for="text" :label="FormDataType.Ilceid.FieldTitle"
        :key="FormData.Ilceid">
        <treeselect :multiple="false" :options="FormDataType.Ilceid.ComboDataArray" placeholder="Seçiniz..."
          v-model="FormData.Ilceid" />
        <treeselect-value :value="FormData.Ilceid" />
      </b-form-group>
      
      <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2"
        :FormDataType="FormDataType.Adres"
        :Value="FormData.Adres"
        :v="v$.FormData.Adres"
        @input="FormData.Adres = $event.target.value"
      />
      <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2"
        :FormDataType="FormDataType.Mahalle" 
        :Value="FormData.Mahalle"
        :v="v$.FormData.Mahalle"
        @input="FormData.Mahalle = $event.target.value"
      />


        <formtextarea class="col-lg-12" :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama"
          :v="v$.FormData.Aciklama" @input="FormData.Aciklama = $event.target.value" />



          <div class="row" v-if="AddEdit == 'Add'">
                    <div class="col-md-10">
 

                      <template class="" v-for="(Data, index) in Belgeler"
                                            :key="index">
                                            <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.Fileurl">
                                              <span style="margin-right: 10px; color: #ff69b4" class="fas fa-file-image"
                                                v-if="(Data.dosya_uzantisi == '.png' || Data.dosya_uzantisi == '.jpg' || Data.dosya_uzantisi == '.jpeg')"></span>
                                              <span style="margin-right: 10px; color: green" class="fas fa-file-excel"
                                                v-if="Data.dosya_uzantisi == '.xlsx'"></span>
                                              <span style="margin-right: 10px; color: purple" class="fas fa-file-pdf"
                                                v-if="Data.dosya_uzantisi == '.pdf'"></span>
                                              <span style="margin-right: 10px; color: blue" class="fas fa-file-word"
                                                v-if="Data.dosya_uzantisi == '.docx'"></span>
                                            </a>
                                            {{ Data.Filename }}
                                            <i class="far fa-trash-alt" @click="BelgeSil(index)"></i>
                                            &nbsp;&nbsp;&nbsp;
                                          </template>
                      </div>
                                        <div class="col-md-2">
                                          <div class="custom-file-input float-end">   <input
                                              ref="file" type="file" @change="FileUpload($event)"
                                              accept=".jpg, .jpeg, .png, .12, .pdf, .docx, .tar, .zip"> </div>
                                        </div>
                                      </div>
      </div>
      <button class="btn btn-primary" type="submit" :disabled="KaydetButton">
        {{ KaydetButton ? 'Kaydediliyor' : 'Kaydet'}}
      </button>
    </Form>
  </b-modal>
</template>
